import React from 'react';

const Main = ({ children }) => {
  return <main>{children}</main>;
};

export { Main };
